// extracted by mini-css-extract-plugin
module.exports = {"message-meta":"FQXI06","message-time":"_2mHxvC","message-delivery-status":"_1k5eAp","message-time-dark":"_1x9L2f"};